import React, { useState } from 'react';
import { useAssetTypes } from '../hooks/useAssetTypes';
import { Button } from '../components/ui/button';
import LoadingSpinner from '../components/common/LoadingSpinner';
import AssetTypeList from '../components/assets/AssetTypeList';
import AssetList from '../components/assets/AssetList';
import type { AssetType } from '../types/asset';

const Assets: React.FC = () => {
  const [selectedAssetType, setSelectedAssetType] = useState<AssetType | null>(null);
  const { isLoading } = useAssetTypes(true);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-64">
        <LoadingSpinner size="lg" />
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {/* Header */}
      <div>
        <h1 className="text-3xl font-bold text-gray-900">Activos</h1>
        <p className="mt-1 text-sm text-gray-600">
          Gestiona los tipos de activos y sus instancias
        </p>
      </div>

      {/* Content */}
      {!selectedAssetType ? (
        <AssetTypeList
          onSelectType={(assetType: AssetType) => setSelectedAssetType(assetType)}
          selectedTypeId={undefined}
        />
      ) : (
        <div className="space-y-4">
          <Button
            variant="outline"
            onClick={() => setSelectedAssetType(null)}
          >
            ← Volver a Tipos de Activos
          </Button>
          <AssetList assetType={selectedAssetType} />
        </div>
      )}
    </div>
  );
};

export default Assets;
